export default "__VITE_ASSET__B9MUZMx8__"